export const DefaultMinFileSize = 0;
export const DefaultMaxFileSize = 1024 * 1024 * 50;
export const DefaultMaxFiles = 1;
